module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-36a75a2b.png";